import { OverlayImplementation } from '../../../libs/gin-tonic/helpers/overlay/overlay-implementation';
import { OverlayOptions } from '../../../libs/gin-tonic/helpers/overlay/overlay-options';
import { OverlayPositionBuilder } from '../../../libs/gin-tonic/helpers/overlay/position/overlay-position-builder';

export class Menu extends OverlayImplementation {
	constructor(element: HTMLElement) {
		super(element);
	}

	initializePortal(portal: HTMLElement): void {
		portal.classList.add('c-menu-overlay__container');
		portal.innerHTML = this.element.innerHTML;
	}

	getOverlayOptions(trigger?: HTMLElement): OverlayOptions {
		return {
			positionStrategy: OverlayPositionBuilder.connectedTo(trigger)
				.withFallbackPosition(
					{
						originX: 'start',
						originY: 'bottom'
					},
					{
						overlayX: 'end',
						overlayY: 'top'
					}
				)
				.withOffsetX(47)
				.withOffsetY(-10),
			hasBackdrop: true,
			closeOnEscPressed: true,
			closeOnBackdropClick: true,
			disposeAfterClose: true,
			closeOnClick: true,
			detachBackdropBeforeClose: true,
			backdropClassName: 'c-menu-overlay__backdrop'
		};
	}
}
